<template>
	<WwModal
		:modal-id="DABVENT_MODAL"
		modal-border-radius="rounded-t-2xl md:rounded-3xl"
		modal-margin="m-0"
		modal-padding="p-2 md:p-3"
		modal-position="items-end md:items-center"
		max-width="w-full md:max-w-xl"
		hide-footer
		:transition-direction="!isMobile ? 'down' : 'bottom'"
	>
		<template #body>
			<GleamEmbed :embed-html="modalData.embed" />
		</template>
	</WwModal>
</template>

<script>
import {
	mapGetters,
	mapMutations
} from 'vuex'

import GleamEmbed from '@/components/marketing/GleamEmbed.vue'
import WwModal from '@/components/UI/WwModal.vue'
import { DABVENT_MODAL } from '@/constants/modal/names.js'
export default {
	components: {
		WwModal,
		GleamEmbed
	},
	props: {
		modalData: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			DABVENT_MODAL,
			isExpanded: false
		}
	},
	computed: {
		...mapGetters([ 'isMobile' ])
	},
	methods: {
		...mapMutations('slideOver', [ 'showSlideOver' ]),
		...mapMutations('modal', [ 'closeModal' ])
	}
}
</script>
